module.exports = __webpack_public_path__ + "img/BLANCO_Aprendizaje.b9df2b5b.png";